import { createReducer } from '@common/redux-utils';

import {
  FailedEmailActionType,
  SearchFailedEmailListStartAction,
  SearchFailedEmailListSuccessAction,
  SearchFailedEmailListFailureAction,
  SetFailedEmailListAction,
  SetOwnershipAction,
  SetFailedEmailLoadingAction
} from 'src/failed-email/failed-email.actions';

import { DocumentHistoryViewModel } from '@models/DocumentHistory';

export interface FailedEmailState {
  readonly emailList: Array<DocumentHistoryViewModel>;
  readonly query?: string;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly orderBy: string;
  readonly message: string;
  readonly loading?: boolean;
}

export const initialFailedEmailState: FailedEmailState = {
  emailList: [] as Array<DocumentHistoryViewModel>,
  query: '',
  pageNumber: 0,
  pageSize: 10,
  pageCount: 10,
  orderBy: '',
  message: ''
};

/***** Search Failed Email List ****/
function handleSearchFailedEmailListStart(
  state: FailedEmailState,
  action: SearchFailedEmailListStartAction
): FailedEmailState {
  return {
    ...state,
    query: action.query,
    loading: true
  };
}

function handleSearchFailedEmailListSuccess(
  state: FailedEmailState,
  action: SearchFailedEmailListSuccessAction
): FailedEmailState {
  return {
    ...state,
    pageNumber: action.pageNumber,
    pageSize: action.result.pageSize,
    pageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    emailList: action.result.results,
    orderBy: action.orderBy,
    loading: false
  };
}
function handleSearchFailedEmailListFailure(
  state: FailedEmailState,
  action: SearchFailedEmailListFailureAction
): FailedEmailState {
  return {
    ...state,
    message: action.error,
    loading: false
  };
}

function handleSetFailedEmailLoading(state: FailedEmailState, action: SetFailedEmailLoadingAction): FailedEmailState {
  return {
    ...state,
    loading: action.loading
  };
}

function handleSetFailedEmailList(state: FailedEmailState, action: SetFailedEmailListAction): FailedEmailState {
  return {
    ...state,
    pageNumber: action.pageNumber,
    pageSize: action.pageSize,
    pageCount: Math.ceil(action.totalResults / action.pageSize),
    emailList: action.results,
    orderBy: action.orderBy,
    query: action.query,
  };
}

function handleSetOwnership(state: FailedEmailState, action: SetOwnershipAction): FailedEmailState {
  return {
    ...state
  };
}

export const FailedEmailReducer = createReducer<FailedEmailState, FailedEmailActionType>(initialFailedEmailState, {
  [FailedEmailActionType.SearchFailedEmailListStart]: handleSearchFailedEmailListStart,
  [FailedEmailActionType.SearchFailedEmailListSuccess]: handleSearchFailedEmailListSuccess,
  [FailedEmailActionType.SearchFailedEmailListFailure]: handleSearchFailedEmailListFailure,
  [FailedEmailActionType.SetFailedEmailLoading]: handleSetFailedEmailLoading,
  [FailedEmailActionType.SetFailedEmailList]: handleSetFailedEmailList,
  [FailedEmailActionType.SetOwnership]: handleSetOwnership
});



// WEBPACK FOOTER //
// ./src/failed-email/failed-email.reducer.tsx